const PlaneIcon = ({ size }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 31 27">
      <path d="M8.793 12.3438H23.4414L4.80862 4.37502L8.793 12.3438ZM8.793 15.1563L4.80862 23.1836L23.4414 15.1563H8.793ZM3.57816 0.800801L29.8282 12.0508C30.5313 12.3438 31 13.0469 31 13.8086C31 14.5117 30.5313 15.2149 29.8282 15.5078L3.57816 26.7578C2.87503 27.0508 1.99612 26.875 1.46878 26.2891C0.941436 25.7617 0.824249 24.8828 1.17581 24.1797L6.39066 13.75L1.17581 3.37893C0.824249 2.6758 0.941436 1.79689 1.46878 1.21096C1.99612 0.683613 2.87503 0.507832 3.57816 0.800801Z" />
    </svg>
  )
}

export default PlaneIcon
